import { render, staticRenderFns } from "./ProjectTiles.vue?vue&type=template&id=5b0c2814&scoped=true"
import script from "./ProjectTiles.vue?vue&type=script&lang=js"
export * from "./ProjectTiles.vue?vue&type=script&lang=js"
import style0 from "./ProjectTiles.vue?vue&type=style&index=0&id=5b0c2814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c2814",
  null
  
)

export default component.exports